import api from './api'

class HeartbeatService {
  constructor() {
    this.intervalId = null
    this.HEARTBEAT_INTERVAL = 30000
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
  }

  start() {
    if (this.intervalId) {
      return 
    }

    // Send initial heartbeat
    this.sendHeartbeat()

    // Set up interval
    this.intervalId = window.setInterval(() => {
      this.sendHeartbeat()
    }, this.HEARTBEAT_INTERVAL)

    // Also send heartbeat on visibility change (when user returns to tab)
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
    
    console.log('Heartbeat service started')
  }

  stop() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId)
      this.intervalId = null
    }

    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    
    console.log('Heartbeat service stopped')
  }

  handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
      this.sendHeartbeat()
    }
  }

  async sendHeartbeat() {
    try {
      await api.post('/heartbeat')
    } catch (error) {
      // Silently fail - don't disrupt user experience
      console.debug('Heartbeat failed:', error)
    }
  }

  // Get online friends
  async getOnlineFriends() {
    try {
      const response = await api.get('/heartbeat', { params: { friends: 'true' } })
      return response.data
    } catch (error) {
      console.error('Failed to get online friends:', error)
      return { onlineCount: 0, onlineFriends: [] }
    }
  }
}

// Export singleton instance
export const heartbeatService = new HeartbeatService()
export default heartbeatService